import React from 'react';
import { Flex, Box, AspectRatio, Image } from '@chakra-ui/react';
import GameInfoPromo from '../GameInfoPromo/gameInfoPromo';
import FeaturedRecommendedGames from '../FeaturedRecommendedGames/featuredRecommendedGames';
import RecommendedGames from '../RecommendedGames/recommendedGames';

export const HeaderPromo = ({image, smallerImage} : {image: string, smallerImage: string}) => {
    return (
        <Flex
            p='40px 40px'
            direction="column"
            gridGap="16px"

        >
            <Flex width='100%' position='relative'>
                <Flex position='absolute' w='100%' h='100%'>
                    <Image src={!image ? '/assets/default/banner-game.png' : image} filter="blur(18px)" zIndex="0"/>
                </Flex>
            <AspectRatio ratio={16/9} width='100%'>
               <Image src={!image ? '/assets/default/banner-game.png' : image}/>
            </AspectRatio>
                <Flex position='absolute' h='48%' w='100%' top='44%' justifyContent='space-between' zIndex='999999' gridGap='24px' alignItems='flex-end'>
                    <GameInfoPromo />
                    <RecommendedGames recommendedGameImage={smallerImage}/>
                </Flex>
                <Box position='absolute' w='100%' h='100%' top='0' bgGradient='linear-gradient(360deg, #171717 0%, rgba(24, 23, 24, 0.44) 62.12%)'/>
            </Flex>
            <FeaturedRecommendedGames smallerImage={smallerImage}/>
    </Flex>
    );
};

export default HeaderPromo;
